import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/constants';

const Spinner = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => (props.small ? `1.3em` : props.xs ? `18px` : `51px`)};
  height: ${(props) => (props.small ? `1.3em` : props.xs ? `18px` : `51px`)};

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${(props) => (props.small ? `1.3em` : props.xs ? `18px` : `51px`)};
    height: ${(props) => (props.small ? `1.3em` : props.xs ? `18px` : `51px`)};

    border: ${(props) => (props.small ? `3px` : props.xs ? `2px` : `4px`)} solid
      ${colors.orange};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => (props.light ? colors.white : colors.coral)}
      transparent transparent transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default (props) => (
  <Spinner {...props}>
    <div />
    <div />
    <div />
    <div />
  </Spinner>
);
